<template>
  <div>
    <el-card class="box-card">
      <el-form :model="editFormfeiyongbaoxiao" ref="editFormfeiyongbaoxiaoRef" label-width="170px">
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">费用类别(必选)</span>
          </label>
          <el-select v-model="editFormfeiyongbaoxiao.fytype" placeholder="请选择" style="width: 100%">
            <el-option label="请选择" value="0"></el-option>
            <el-option label="招待费" value="1"></el-option>
            <el-option label="办公费" value="2"></el-option>
            <el-option label="税费" value="3"></el-option>
            <el-option label="水电费" value="4"></el-option>
            <el-option label="租赁费" value="5"></el-option>
            <el-option label="其他" value="6"></el-option>
            <el-option label="运输快递费" value="7"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">收款单位(必填)</span>
          </label>
          <el-input v-model="editFormfeiyongbaoxiao.shoukuandanwei"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">银行账号(必填)</span>
          </label>
          <el-input v-model="editFormfeiyongbaoxiao.yinhangzhanghao"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">开户行(必填)</span>
          </label>
          <el-input v-model="editFormfeiyongbaoxiao.kaihuhang"></el-input>
        </el-form-item>
        <el-form-item label="垫付人(可选)" class="addAdminForm">
          <el-input v-model="editFormfeiyongbaoxiao.dianfuren" placeholder="如果垫付了费用,此处必填"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">付款原因(必填)</span>
          </label>
          <el-input v-model="editFormfeiyongbaoxiao.reason"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">金额(必填)</span>
          </label>
          <el-input v-model="editFormfeiyongbaoxiao.money"></el-input>
        </el-form-item>
        <el-form-item label="备注(可选)" class="addAdminForm">
          <el-input v-model="editFormfeiyongbaoxiao.beizhu"></el-input>
        </el-form-item>
        <el-form-item label="附件(可选)" class="addAdminForm">
          <TencentyunCosUploadMultiImgOrPdf ref="MultiImgOrPdf" @change="addTencentyunCosUploadMultiImgOrPdf"></TencentyunCosUploadMultiImgOrPdf>
          默认采用上次的附件，如果附件有改动，请把所有附件都重新上传。
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clicksave">保存</el-button>
          <el-button type="info" @click="clickreturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
import TencentyunCosUploadMultiImgOrPdf from '@/components/TencentyunCosUploadMultiImgOrPdf.vue'
Vue.use(VueAxios, axios)

export default {
  components: {
    TencentyunCosUploadMultiImgOrPdf
  },
  data () {
    return {
      editFormfeiyongbaoxiao: {
        id: 0,
        fytype: '0',
        shoukuandanwei: '',
        yinhangzhanghao: '',
        kaihuhang: '',
        dianfuren: '',
        reason: '',
        money: '',
        beizhu: '',
        attachment: ''
      }
    }
  },
  mounted () {

  },
  methods: {
    LoadData (row) {
      console.log(row)
      this.editFormfeiyongbaoxiao.id = row.Id
      this.editFormfeiyongbaoxiao.fytype = row.Fytype.toString()
      this.editFormfeiyongbaoxiao.shoukuandanwei = row.Shoukuandanwei
      this.editFormfeiyongbaoxiao.yinhangzhanghao = row.Yinhangzhanghao
      this.editFormfeiyongbaoxiao.kaihuhang = row.Kaihuhang
      this.editFormfeiyongbaoxiao.dianfuren = row.Dianfuren
      this.editFormfeiyongbaoxiao.reason = row.Reason
      this.editFormfeiyongbaoxiao.money = row.Money
      this.editFormfeiyongbaoxiao.beizhu = row.Beizhu
      this.editFormfeiyongbaoxiao.attachment = row.Attachment

      this.$refs.MultiImgOrPdf.cleardata()
    },
    clickreturn () {
      this.$emit('triggerFunc', '')
    },
    clicksave () {
      this.apiEditShenPiNewFyBxChaiLv1()
    },
    addTencentyunCosUploadMultiImgOrPdf (url) {
      this.editFormfeiyongbaoxiao.attachment = url
    },
    apiEditShenPiNewFyBxChaiLv1: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: that.editFormfeiyongbaoxiao.id,
        fytype: that.editFormfeiyongbaoxiao.fytype,
        shoukuandanwei: that.editFormfeiyongbaoxiao.shoukuandanwei,
        yinhangzhanghao: that.editFormfeiyongbaoxiao.yinhangzhanghao,
        kaihuhang: that.editFormfeiyongbaoxiao.kaihuhang,
        dianfuren: that.editFormfeiyongbaoxiao.dianfuren,
        reason: that.editFormfeiyongbaoxiao.reason,
        money: that.editFormfeiyongbaoxiao.money,
        beizhu: that.editFormfeiyongbaoxiao.beizhu,
        attachment: that.editFormfeiyongbaoxiao.attachment
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditShenPiNewFyBxChaiLv1, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 365px;
}
</style>
